<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Vendor Order View</h3>

      <div class="search_bar mb-1">
        <b-card>
          <b-row class="mb-1">
            <!-- <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.vendor_selected"
                :options="vendor_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.channel_selected"
                :options="channel_options"
              />
            </b-col> -->
            <b-col cols="2" class="pr-1" v-if="this.$store.state.user_obj.name != 'aml_comvita' && this.$store.state.user_obj.name != 'aml_vendor_master' && this.$store.state.user_obj.account_type != 'vendor_2'">
              <b-form-select
                size="sm"
                v-model="search_criteria.collect_status_selected"
                :options="collect_status_options"
              />
            </b-col>

            <b-col cols="2" class=" pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.tracking_status_selected"
                :options="tracking_status_options"
              />
            </b-col>

            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="sort_by_col"
                :options="sort_by_col_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="sort_by_order"
                :options="sort_by_order_options"
              />
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="2" class="pr-1" style="text-align: center">
              <strong>Order Date</strong>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.end_at"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col cols="2" class="pr-1" style="text-align: center">
              <strong>Scheduled Delivery Date</strong>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.s_start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.s_end_at"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col cols="2" class="pr-1" style="text-align: center">
              <strong>Ready for Pickup Date</strong>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.pickup_start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.pickup_end_at"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="4" class="pl pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Order# / Channel SKU / CN#"
                v-model="search_criteria.keyword"
               @keyup.enter="onSearch"></b-form-input>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button 
              v-if="checkPermission($store.state.user_obj, 'Vendor Management', 'Order View', 'Export CSV', true)"
              class="btn-action" size="sm" variant="info" @click="onExport">
                Export
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3" 
      v-if="checkPermission($store.state.user_obj, 'Vendor Management', 'Order View', 'Action Bar', true)">
        <b-card>
          <b-row class="mt-1 mb-1">
            <b-col class="">
              <b-button
                v-if="$store.state.user_obj.account_type != 'vendor_warehouse'"
                class="btn-action mr-5"
                size="sm"
                variant="info"
                @click="showModal_createShipment()"
              >
                Generate Collection Note
              </b-button>

              <!-- <b-button
                v-if="$store.state.user_obj.account_type != 'vendor_warehouse'"
                class="btn-action"
                size="sm"
                variant="info"
                @click="onBulkAction('Ready for Fulfilment [Vendor]')"
              >
                Ready For Fulfilment [Vendor]
              </b-button> -->

              <b-button
                v-if="$store.state.user_obj.account_type != 'vendor_warehouse'"
                class="btn-action"
                size="sm"
                variant="info"
                @click="onBulkAction('Ready for Pickup')"
              >
                Ready for Pickup
              </b-button>

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                v-if="
                  $store.state.user_obj.account_type != 'vendor_warehouse' &&
                  $store.state.user_obj.account_type != 'vendor'
                "
                @click="onBulkAction('Received from Vendor')"
              >
                Received from Vendor
              </b-button>

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="bulkDownloadWaybill"
                >Download Waybill & Pick List</b-button
              >

              <b-button
                v-if="$store.state.user_obj.account_type != 'vendor_warehouse'"
                class="btn-action ml-2"
                size="sm"
                variant="danger"
                @click="onBulkAction('Pending')"
              >
                Back to Pending
              </b-button>

              <!-- <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="bulkDownloadPL"
              >
                Download Pick List
              </b-button> -->
            </b-col>
          </b-row>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>
      <!-- <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination> -->

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select
            size="sm"
            v-model="sel_table_limit"
            :options="[50, 100, 200, 500]"
            @change="getVendorOrder()"
          />
        </b-col>
        <b-col class="pl-0 pr-1">
          <b-pagination
            size="sm"
            :total-rows="total_rows"
            v-model="currentPage"
            :per-page="sel_table_limit"
            @change="onPageChange"
            :limit="PAGING_LIMIT"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="400px"
        :items="items"
        :fields="fields"
        :tbody-tr-class="rowClass"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>

        <template v-slot:head(vendor_name)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(cn_number)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(channel)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(order_date)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(scheduled_delivery_date)="data">
          <div @click="sortCol('id')">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == 'id' && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == 'id' && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(order_number)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(channel_sku)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(product_description)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(product_quantity)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:head(collect_status)="data">
          <div @click="sortCol(data.column)">
            {{ data.label }}
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'ASC'"
              icon="arrow-up"
            />
            <font-awesome-icon
              v-if="sort_by_col == data.column && sort_by_order == 'DESC'"
              icon="arrow-down"
            />
          </div>
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <!-- <template v-slot:cell(order_number)="data">
          <router-link
            :to="{
              name: 'order_master_detail',
              params: { order_master_id: data.item.order_id }
            }"
          >
            {{ data.item.order_number }}
          </router-link>
        </template> -->

        <template v-slot:cell(payment_status)="data"> - </template>

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
            <span
              v-if="data.item.order_import_status == 'pending'"
              class="dot_yellow"
            ></span>
            <span
              v-if="data.item.order_import_status == 'received'"
              class="dot_green"
            ></span>
          </div>
        </template>

        <template v-slot:cell(stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.stock_status }}</span>

            <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.stock_status == 'OOS'" class="dot_red"></span>
            <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
            <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
            <span
              v-if="data.item.fulfilment_status == 'pending'"
              class="dot_yellow"
            ></span>
            <span
              v-if="data.item.fulfilment_status == 'completed'"
              class="dot_green"
            ></span>
            <span
              v-if="data.item.fulfilment_status == 'fulfiled'"
              class="dot_green"
            ></span>
          </div>
        </template>

        <!-- <template v-slot:cell(delivery_status)="data">
          <div>
            
            <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
            <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>

          </div>
        </template> -->

        <template v-slot:cell(action)="data">
          <b-button
            v-if="data.item.collect_status == 'pending'"
            class="btn-action"
            size="sm"
            variant="success"
            @click="doReadyCollect(data.item)"
            >Ready</b-button
          >

          <b-button
            v-if="data.item.collect_status == 'ready_for_pickup'"
            class="btn-action"
            size="sm"
            variant="success"
            @click="doComplete(data.item)"
            >Complete</b-button
          >

          <!-- <b-button
            v-if="data.item.collect_status != 'completed'"
            class="btn-action"
            size="sm"
            variant="danger"
            @click="doCancelCollect(data.item)"
            >Cancel</b-button
          > -->
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_createShipment" centered hide-footer hide-header size="xl">
        <div class="d-block">
          <b-row class="mb-2">
            <b-col>
              <strong>Generate Collection Note</strong>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="col-2">
              <strong>Reference #</strong>
            </b-col>
            <b-col
              ><b-form-input
                size="sm"
                type="text"
                placeholder="(Optional)"
                v-model="collection_note_obj.cn_number"
              ></b-form-input
            ></b-col>
          </b-row>
          <hr />

          <b-table
            responsive
            small
            outlined
            striped
            hover
            :items="collection_note_obj.orders"
            :fields="collection_note_product_fields"
          >
            <template v-slot:head(chk_box)="data">
              <b-form-checkbox
                size="sm"
                plain
                id="chkbox_all"
                value="all"
                v-model="check_all_products"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(chk_box)="data">
              <b-form-checkbox
                size="sm"
                class="chkbox_row"
                plain
                :id="'chkbox_row_' + data.index"
                v-model="data.item.is_checked"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(item_number)="data">
              {{ data.item.item_number }}
              <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_number"
            ></b-form-input> -->
            </template>

            <template v-slot:cell(product_description)="data">
              <div
                class="text-ellipsis"
                v-b-tooltip.hover.right
                :title="data.item.product_description"
              >
                {{ data.item.product_description }}
              </div>
            </template>

            <template v-slot:cell(pickup_qty)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.pickup_qty"
              ></b-form-input>
            </template>

            <template v-slot:cell(supplier_lot)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.supplier_lot"
              ></b-form-input>
            </template>

            <template v-slot:cell(expiration_date)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.expiration_date"
              ></b-form-input>
            </template>

            <template v-slot:cell(product_remark)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.product_remark"
              ></b-form-input>
            </template>

            <template v-slot:cell(diff_qty)="data">
              <span v-if="data.item.gols_qty == 0" class="dot_yellow"></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                  data.item.gols_qty - data.item.expected_qty != 0
                "
                class="dot_red"
              ></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                  data.item.gols_qty - data.item.expected_qty == 0
                "
                class="dot_green"
              ></span>

              <span>{{ data.item.gols_qty - data.item.expected_qty }}</span>
            </template>

            <template v-slot:cell(cover_image)="data">
              <img :src="data.item.cover_image" width="50" />
            </template>
          </b-table>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_createShipment"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="showModal_confirmGenCN()"
            >Submit</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_confirmGenCN" centered hide-footer hide-header size="xl">
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to generate Collection Note?</strong>
            </b-col>
          </b-row>

          <b-row class="mb-2" v-if="collection_note_obj.cn_number">
            <b-col class="col-2">
              <strong>Reference #</strong>
            </b-col>
            <b-col>{{ collection_note_obj.cn_number }}</b-col>
          </b-row>

          <b-table
            responsive
            small
            outlined
            striped
            hover
            :items="collection_note_obj.orders"
            :fields="collection_note_product_fields"
          >
            <template v-slot:head(chk_box)="data">
              <b-form-checkbox
                size="sm"
                plain
                id="chkbox_all"
                value="all"
                v-model="check_all_products"
              ></b-form-checkbox>
            </template>

            <template v-slot:cell(chk_box)="data">
              <b-form-checkbox
                size="sm"
                class="chkbox_row"
                plain
                :id="'chkbox_row_' + data.index"
                v-model="data.item.is_checked"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(item_number)="data">
              {{ data.item.item_number }}
            </template>

            <template v-slot:cell(product_description)="data">
              <div
                class="text-ellipsis"
                v-b-tooltip.hover.right
                :title="data.item.product_description"
              >
                {{ data.item.product_description }}
              </div>
            </template>

            <template v-slot:cell(pickup_qty)="data">
              <span>
                {{ data.item.pickup_qty }}
              </span>
            </template>
          </b-table>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmGenCN"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="confirmGenCN(updating_item)"
            >Confirm</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "vendor_name",
    label: "Vendor",
  },
  {
    key: "cn_number",
    label: "CN#",
  },
  {
    key: "channel",
    label: "Channel",
  },
  {
    key: "order_date",
    label: "Order Date",
  },
  {
    key: "scheduled_delivery_date",
    label: "Scheduled Delivery Date",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "brand",
    label: "Brand",
  },
  {
    key: "channel_sku",
    label: "Channel SKU",
  },
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_description",
    label: "Description",
  },
  {
    key: "product_quantity",
    label: "Quantity",
    class: "txt_camelcase center_align",
  },
  {
    key: "collect_status",
    label: "Collect Status",
    class: " center_align",
  },
  {
    key: "tracking_status",
    label: "Tracking Status",
    class: " center_align",
  },
];

const fields_vendor2 = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "vendor_name",
    label: "Vendor",
  },
  {
    key: "cn_number",
    label: "CN#",
  },
  {
    key: "channel",
    label: "Channel",
  },
  {
    key: "order_date",
    label: "Order Date",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "brand",
    label: "Brand",
  },
  {
    key: "channel_sku",
    label: "Channel SKU",
  },
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_description",
    label: "Description",
  },
  {
    key: "product_quantity",
    label: "Quantity",
    class: "txt_camelcase center_align",
  },
  {
    key: "tracking_status",
    label: "Tracking Status",
    class: " center_align",
  },
];
import global_function from "../mixins/global_function";

export default {
  name: "VendorOrder",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      sel_table_limit: this.TABLE_LIMIT,
      courier_options: [],
      export_date: {
        start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: null,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null,
      },
      search_criteria: {
        keyword: "",
        channel_selected: null,
        start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        s_start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        s_end_at: moment().add(7, "d").format("YYYY-MM-DD"),
        pickup_start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        pickup_end_at: moment().add(7, "d").format("YYYY-MM-DD"),
        collect_status_selected: "pending",
        stock_status_selected: null,
        fulfilment_status_selected: null,
        vendor_selected: null,
        tracking_status_selected: null,
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      vendor_options: [
        {
          value: null,
          text: "All Vendors",
        },
        {
          value: "Searching C",
          text: "Searching C",
        },
        {
          value: "Geeker Group",
          text: "Geeker Group",
        },
        {
          value: "Kidsland",
          text: "Kidsland",
        },
      ],

      channel_options: [
        {
          value: null,
          text: "All Channels",
        },
      ],

      collect_status_options: [
        {
          value: null,
          text: "All Collect Status",
        },
        {
          value: "Ready for Fulfilment [Vendor]",
          text: "Ready for Fulfilment [Vendor]",
        },
        {
          value: "Ready for Pickup",
          text: "Ready for Pickup",
        },
        {
          value: "Received from Vendor",
          text: "Received from Vendor",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "Cancel",
          text: "Cancel",
        },
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status",
        },
        {
          value: "-",
          text: "-",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "available",
          text: "Available",
        },
        {
          value: "committed",
          text: "Committed",
        },
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status",
        },
        {
          value: "approve",
          text: "Fulfilled",
        },
        {
          value: "pending",
          text: "Pending",
        },
      ],

      tracking_status_options: [
        {
          value: null,
          text: "All Tracking Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In_Transit",
          text: "In_Transit",
        },
        {
          value: "Successful",
          text: "Successful",
        },
        {
          value: "Cancelled",
          text: "Cancelled",
        },
        {
          value: "Shipped_Ext",
          text: "Shipped_Ext",
        },
        {
          value: "Returned_to_Warehouse",
          text: "Returned_to_Warehouse",
        },
        {
          value: "Rescheduled",
          text: "Rescheduled",
        },
        {
          value: "Unsuccessful_Delay",
          text: "Unsuccessful_Delay",
        },
        {
          value: "Unsuccessful_Other",
          text: "Unsuccessful_Other",
        },
        {
          value: "Unsuccessful_Reject",
          text: "Unsuccessful_Reject",
        },
        {
          value: "Hold",
          text: "Hold",
        },
        {
          value: "Unsuccessful_Unreach",
          text: "Unsuccessful_Unreach",
        },
        {
          value: "Ready_for_Fulfilment",
          text: "Ready_for_Fulfilment",
        },
        {
          value: "Ready_for_Shipment",
          text: "Ready_for_Shipment",
        },
        {
          value: "Ready_for_Redemption",
          text: "Ready_for_Redemption",
        },
        {
          value: "Redemption_Reserved",
          text: "Redemption_Reserved",
        },
        {
          value: "Redemption_Checked-In ",
          text: "Redemption_Checked-In ",
        },
        {
          value: "Redemption_Expired",
          text: "Redemption_Expired",
        },
        {
          value: "Redemption_Checked-Out",
          text: "Redemption_Checked-Out",
        },
        {
          value: "Redemption_Collected",
          text: "Redemption_Collected",
        },
        {
          value: "Redemption_Autovoided",
          text: "Redemption_Autovoided",
        },
        {
          value: "Redemption_Returned",
          text: "Redemption_Returned",
        },
        {
          value: "Redemption_Abnormal",
          text: "Redemption_Abnormal",
        },
        {
          value: "Redemption_CancelledCustomer",
          text: "Redemption_CancelledCustomer",
        },
        {
          value: "Redemption_Cancelled",
          text: "Redemption_Cancelled",
        },
      ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},

      sort_by_col: "order_date",
      sort_by_order: "DESC",
      sort_by_col_options: [
        {
          value: "channel",
          text: "Sort by: Channel",
        },
        {
          value: "order_date",
          text: "Sort by: Order Date",
        },
        {
          value: "order_number",
          text: "Sort by: Order Number",
        },
        {
          value: "channel_sku",
          text: "Sort by: Channel SKU",
        },
        {
          value: "product_quantity",
          text: "Sort by: Pending QTY",
        },
      ],
      sort_by_order_options: [
        {
          value: "DESC",
          text: "Descending",
        },
        {
          value: "ASC",
          text: "Ascending",
        },
      ],

      collection_note: {},
      collection_note_obj: {},
      collection_note_product_fields: [
        {
          key: "channel",
          label: "Channel",
        },
        {
          key: "order_date",
          label: "Order Date",
        },
        {
          key: "order_number",
          label: "Order#",
        },
        {
          key: "channel_sku",
          label: "Channel SKU",
        },
        {
          key: "product_description",
          label: "Description",
        },
        {
          key: "product_quantity",
          label: "Quantity",
          class: "txt_camelcase center_align",
        },
      ],

      collection_note_error_product_fields: [
        {
          key: "channel",
          label: "Channel",
        },
        {
          key: "channel_sku",
          label: "Channel SKU",
        },
        {
          key: "product_description",
          label: "Description",
        },
        {
          key: "product_quantity",
          label: "Pending Quantity",
          class: "txt_camelcase center_align",
        },
        {
          key: "pickup_qty",
          label: "Pickup Quantity",
          class: "txt_camelcase center_align",
        },
        {
          key: "action",
          label: "Action",
          class: "",
        },
      ],
    };
  },
  async created() {
    await this.getVendorOrder();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name,
      });
    }

    if(this.$store.state.user_obj.name == 'aml_comvita' || this.$store.state.user_obj.name == 'aml_vendor_master' || this.$store.state.user_obj.account_type == 'vendor_2'){
      
      this.fields = fields_vendor2;
    }else{
      this.fields = fields;
    }

    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    },
  },
  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST + "/export_order_master.php?";
      for (let i in this.search_criteria) {
        if (this.search_criteria[i] != null) {
          export_url += `&${i}=` + this.search_criteria[i];
        }
      }
      // export_url += "&tracking_number=" + this.search_criteria.tracking_number;
      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWaybill() {
      let checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (item_tmp.is_checked && item_tmp.order_number && item_tmp.order_number != "") {
          checked_items.push(item_tmp.id);
        }
      }

      await this.$http({
        url: this.NODEJS_API_URL + "/print_vendor_waybill",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: false,
          print_waybill: true,
          no_of_waybill: 1,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "waybill.pdf");
        document.body.appendChild(link);
        link.click();
      });

      checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (item_tmp.is_checked && item_tmp.cn_number && item_tmp.cn_number != "") {
          if (checked_items.indexOf(item_tmp.cn_number) == -1) {
            checked_items.push(item_tmp.cn_number);
          }
        }
      }

      await this.$http({
        url: this.NODEJS_API_URL + "/print_vendor_picklist",
        method: "POST",
        data: {
          ids: checked_items,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "picklist.pdf");
        document.body.appendChild(link);
        link.click();
      });

      this.onBulkAction("Ready for Pickup");
    },

    async bulkDownloadPL() {
      let checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (item_tmp.is_checked && item_tmp.cn_number && item_tmp.cn_number != "") {
          if (checked_items.indexOf(item_tmp.cn_number) == -1) {
            checked_items.push(item_tmp.cn_number);
          }
        }
      }

      this.$http({
        url: this.NODEJS_API_URL + "/print_vendor_picklist",
        method: "POST",
        data: {
          ids: checked_items,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "picklist.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async updateImportStatus(row_data, status) {
      if (status == "cancel") {
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async doReadyCollect(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "vendor_order_ready.php",
        data: {
          vendor_order_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Status Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },
    async doComplete(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "vendor_order_complete.php",
        data: {
          vendor_order_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Status Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async doCommitOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_commit.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Commit Order Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async doCancelOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_cancel.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async doHoldOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_hold.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async doFulfillOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Fulfil Order Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async updateFulfillStatus(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async getVendorOrder() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "vendor_order_get.php",
        data: {
          sort_by_col: this.sort_by_col,
          sort_by_order: this.sort_by_order,
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          account_type: this.$store.state.user_obj.account_type,
        },
      });
      this.items = response.data.vendor_orders;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onExport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "vendor_order",
          limit: 999999,
          sort_by_col: this.sort_by_col,
          sort_by_order: this.sort_by_order,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          account_type: this.$store.state.user_obj.account_type,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "vendor_order.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getVendorOrder();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getVendorOrder();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST + "/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async confirmGenCN() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let vendor_order_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          vendor_order_ids.push(this.items[i].id);
        }
      }

      // call action

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "vendor_gen_collection_note.php",
        data: {
          cn_number: this.collection_note_obj.cn_number,
          vendor_order_ids: vendor_order_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Generate CN Success",
        variant: "success",
      });

      if (response && response.data.status == "success") {
        this.$http({
          url: this.NODEJS_API_URL + "/print_vendor_picklist",
          method: "POST",
          data: {
            ids: [response.data.cn_number],
          },
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "picklist.pdf");
          document.body.appendChild(link);
          link.click();
        });

        this.getVendorOrder();

        this.hideModal_confirmGenCN();
        this.hideModal_createShipment();
      } else {
        if (response.data.error == "cn_number_already_exist") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Reference Number Already Exists",
          });
        }
      }
    },

    async onBulkAction(bulk_action) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let vendor_order_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          vendor_order_ids.push(this.items[i].id);
        }
      }

      // call action
      let action_urls = {
        Pending: "vendor_order_ready.php",
        "Ready for Fulfilment [Vendor]": "vendor_order_ready.php",
        "Ready for Pickup": "vendor_order_ready.php",
        "Received from Vendor": "vendor_order_complete.php",
      };

      console.log(action_urls[bulk_action]);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          vendor_order_ids: vendor_order_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          collect_status: bulk_action,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async onBulkApprove() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked && this.items[i].order_import_status == "pending") {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async onBulkFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status != "pending" &&
          this.items[i].fulfilment_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getVendorOrder();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader_full.hide();
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Upload Success",
          variant: "success",
        });
        if (response.data.auto_route_assigned_items) {
          this.$eventHub.$emit("show_auto_route_review", {
            items: response.data.auto_route_assigned_items,
          });
        }
        this.getVendorOrder();
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    showModal_createShipment() {
      this.collection_note_obj = {
        orders: [],
        cn_number: "",
        received_at: moment().format("YYYY-MM-DD"),
      };

      // get checked items
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          this.collection_note_obj.orders.push(JSON.parse(JSON.stringify(this.items[i])));
        }
      }

      if (this.collection_note_obj.orders.length == 0) {
        return;
      }

      this.$refs.modal_createShipment.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_createShipment() {
      this.$refs.modal_createShipment.hide();
    },

    showModal_confirmGenCN(item) {
      this.$refs.modal_confirmGenCN.show();
    },
    hideModal_confirmGenCN() {
      this.$refs.modal_confirmGenCN.hide();
    },

    sortCol(sort_by) {
      if (sort_by == this.sort_by_col) {
        if (this.sort_by_order == "ASC") {
          this.sort_by_order = "DESC";
        } else {
          this.sort_by_order = "ASC";
        }
      } else {
        this.sort_by_col = sort_by;
        this.sort_by_order = "ASC";
      }

      this.getVendorOrder();
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}
.hide{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/VendorOrder.vue